<div class="row mt-2 no-gutters">
  <div class="col">
    <small *ngIf="account.category== 'RENTAL_FLEET'"><a [routerLink]="['/rental-fleet']" class="text-secondary">Admin
        Console</a>
      /<a [routerLink]="['/account-management']" class="text-secondary"> Account Management</a>
      /<a (click)="closeDeviceDetailClicked(null);showSearchResult = false;" class="text-secondary pointer">
        Devices</a></small>
    <small *ngIf="account.category== 'FLEET_MANAGEMENT_COMPANY' || account.category == 'MOBILITY_COMPANY' || account.category == 'FIELD_SERVICE_COMPANY'"><a [routerLink]="['/commercial-fleet']"
        class="text-secondary">Admin Console</a>
      /<a [routerLink]="['/account-management']" class="text-secondary"> Account Management</a>
      /<a (click)="closeDeviceDetailClicked(null);showSearchResult = false;" class="text-secondary"> Devices</a>
    </small>

    <small *ngIf="account.type == 'VEHICLE_SERVICE_PROVIDER' && account.category== 'MOBILITY_SERVICE'"><a
        [routerLink]="['/service-provider/dashboard']" class="text-secondary">Admin Console</a>
      /<a [routerLink]="['/service-provider/account-management']" class="text-secondary"> Account Management</a>
      /<a (click)="closeDeviceDetailClicked(null);showSearchResult = false;" class="text-secondary"> Devices</a>
    </small>
    <small *ngIf="account.category== 'DEALER'"><a [routerLink]="['/dealer']" class="text-secondary">Admin
        Console</a>
      /<a [routerLink]="['/account-management']" class="text-secondary"> Account Management</a>
      /<a (click)="closeDeviceDetailClicked(null);showSearchResult = false;" class="text-secondary pointer">
        Devices</a></small>

    <small *ngIf="account.category== 'CORPORATE' || account.category == 'FINANCING_GROUP'"><a [routerLink]="['/corporate']" class="text-secondary">Admin
        Console</a>
      /<a [routerLink]="['/account-management']" class="text-secondary"> Account Management</a>
      /<a (click)="closeDeviceDetailClicked(null);showSearchResult = false;" class="text-secondary pointer">
        Devices</a></small>
    <small>
      <ng-container *ngIf="isViewDeviceDetail">
        /<a class="text-secondary"> {{selectedDevice.deviceSerialNumber}}</a>
      </ng-container>
    </small>
    <small *ngIf="showSearchResult">
      <a class="text-secondary pointer" (click)="searchResult.onNavSearchClick()">/ Search</a>
      <a *ngIf="selectedSearchItemForView" class="text-secondary"> / {{selectedSearchItemForView}}</a>
    </small>
  </div>
</div>

<div *ngIf="showSearchResult" class="row mt-2 no-gutters">
  <div class="col-12">
    <app-search-results [deviceList]="searchedDeviceList" (selectedItemEmitter)="onSearchItemDetail($event);"
      (selectedItemCloseEmitter)="selectedSearchItemForView=null;" #searchResult></app-search-results>
  </div>
</div>

<div *ngIf="!showSearchResult">
  <div *ngIf="!isViewDeviceDetail else deviceDetail">
    <div class="row py-3 no-gutters">
      <div class="col-12 table-responsive no-gutters">
        <table class="table table-striped tbl-scrollable">
          <thead class="thead-light">
            <tr>
              <!-- removed [disabled]="selectedDevices.length < 1" from below until handled -->
              <th scope="col" width="7%" class="text-center">
                <button class="btn btn-outline-danger py-0 delete-button" [disabled]="true"
                (click)="onDeleteDevices()"><i class="fa fa-trash"></i></button>
              </th>
              <th scope="col" width="7%" class="text-center">
                <button class="btn btn-outline-danger py-0 delete-button" (click)="refreshDeviceList()"><i
                    class="fa fa-refresh"></i></button>
              </th>
              <th scope="col" width="20%">Device Serial #</th>

              <th scope="col" width="22%">Manufacturer</th>

              <th scope="col" width="22%" class="px-0">
                <select (change)="filterSelected()" [(ngModel)]="deviceFilters.status">
                  <option [ngValue]="null">Status</option>
                  <option [ngValue]="item" *ngFor="let item of deviceStatusFilterOptions;">{{item | customText}}
                  </option>
                </select>
              </th>
              <th scope="col" width="22%">Vehicle</th>
            </tr>
          </thead>
          <tbody *ngIf="deviceList && deviceList.length>0; else noDevices" class="max-height-57">
            <tr *ngFor="let device of deviceList; let i = index" class="pointer">
              <th scope="row" width="7%" class="text-center pr-0">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" name="checkbox" class="custom-control-input"
                    [checked]="isDeviceSelected(device.vin)"
                    (change)="onDeviceSelectionChange($event.target.checked, device)" id="device_{{i}}">
                  <label class="custom-control-label" for="device_{{i}}"></label>
                </div>
              </th>
              <td width="7%" class="px-0 text-center" (click)="deviceSelected(device)">
                <img class="vehicle-image-sm" src="{{getDeviceLogo(device)}}" alt="{{device.model}}" />
              </td>
              <td scope="row" width="20%" (click)="deviceSelected(device)">{{device.deviceSerialNumber}}</td>
              <td width="22%" [ngClass]="device.telematicsProvider ? '': 'text-center'"
                (click)="deviceSelected(device)"><span
                  *ngIf="device.telematicsProvider; else valueNotAvailable">{{device.telematicsProvider}}</span></td>
              <td width="22%" (click)="deviceSelected(device)">
                <!-- <i [ngClass]="{'DISABLED':'fa fa-check-circle text-success', 'NONE':'fa fa-exclamation-circle text-danger', 'ATTACHED':'fa fa-exclamation-circle text-danger', 'ENABLED':'fa fa-minus-circle text-warning',
              'LINKED':'fa fa-minus-circle text-warning'}[device.dongleStatus]"></i> -->
                <i
                  [ngClass]="{'NONE':'fa fa-exclamation-circle text-danger','ATTACHED':'fa fa-minus-circle text-warning', 'ENABLED':'fa fa-check-circle text-warning', 'LINKED':'fa fa-check-circle text-success', 'UNLINKED':'fa fa-exclamation-circle text-danger', 'DELETED':'fa fa-exclamation-circle text-danger','DISABLED':'fa fa-exclamation-circle text-danger'}[device.dongleStatus]"></i>
                {{device.dongleStatus | customText}}
              </td>
              <td scope="row" width="22%" (click)="deviceSelected(device)">{{device.vin}}</td>
            </tr>
          </tbody>
        </table>
        <ng-template #valueNotAvailable>
          <span>-</span>
        </ng-template>
      </div>
      <!-- <div class="col-12 text-right">
        <span *ngIf="previousPage != null" class="pointer" (click)="getPreviousPage()">
          << Previous</span>
            <span *ngIf="nextPage != null" class="pointer" (click)="getNextPage()">&nbsp;&nbsp;&nbsp;&nbsp;Next >>
            </span>
      </div> -->
    </div>
    <ng-template #noDevices>
      <div class="col-12 text-center mt-5 mb-5 text-muted">
        <h3>No device available</h3>
      </div>
    </ng-template>
  </div>
  <ng-template #deviceDetail>
    <!-- <app-view-device-detail [deviceData]="selectedDevice" [selectedVin]="selectedVin"
      (closeEmitter)="closeDeviceDetailClicked($event)">
    </app-view-device-detail> -->
    <app-view-device-detail [deviceData]="selectedDevice" (closeEmitter)="closeDeviceDetailClicked($event)">
    </app-view-device-detail>
  </ng-template>
</div>

<!-- Add device modal -->
<!-- <div class="modal fade" id="addDevice" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="addDeviceTitle">Add Device</h5>
        <button id="closeAddDevice" type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" (click)="resetAddDeviceForm()">&times;</span>
        </button>
      </div>
      <form name="addDevice" #addDeviceForm="ngForm" novalidate (ngSubmit)="onCreateDevice(addDeviceForm)">
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-2 col-md-2 col-sm-3 col-3 pr-0 text-center">
              <div *ngIf="!device.logo">
                <img src="assets/images/placeholder.png" class="img-thumbnail full-img">
              </div>
              <div *ngIf="device.logo">
                <img [src]="device.logo" class="img-thumbnail full-img">
              </div>
              <div style="height:0px;overflow:hidden">
                <input #uploaddeviceLogo (click)="uploaddeviceLogo.value=null" id="uploadLogoInput"
                  name="uploadLogoInput" type="file" (change)="uploadDeviceLogo($event)" accept=".jpg,.png">
              </div>
              <small><a style="cursor:pointer" (click)="uploadDeviceLogoClicked()"><u>Upload Logo</u></a></small>
            </div>
            <div class="col-lg-10 col-md-10 col-sm-9 col-9">
              <div class="form-group">
                <label for="vin"><span class="maroon astrisk">&#10033;&nbsp;</span>VIN</label>
                <input type="text" class="form-control" id="vin" name="vin" placeholder="vin" required
                  [(ngModel)]="device.vin" #vin="ngModel" pattern="[A-Z0-9]{17}" minlength="17">
                <small class="text-danger text-center" *ngIf="vin.errors && addDeviceForm.submitted">
                  <p class="mb-0" *ngIf="vin.errors.required">*Required</p>
                  <p class="mb-0" *ngIf="!vin.errors.required">Invalid vin</p>
                </small>
              </div>
              <div class="form-group">
                <label for="make"><span class="maroon astrisk">&#10033;&nbsp;</span>Make</label>
                <input type="text" class="form-control" id="make" name="make" placeholder="Make" required
                  [(ngModel)]="device.make" #make="ngModel" (blur)="invalidMake=false">
                <small class="text-danger text-center" *ngIf="make.errors && addDeviceForm.submitted">
                  <p class="mb-0" *ngIf="make.errors.required">*Required</p>
                </small>
                <small class="text-danger text-center" *ngIf="!make.errors && addDeviceForm.submitted && invalidMake">
                  <p class="mb-0">Make can only be Nissan or Infiniti</p>
                </small>
              </div>
              <div class="form-group">
                <label for="model"><span class="maroon astrisk">&#10033;&nbsp;</span>Model</label>
                <input type="text" class="form-control" id="model" name="model" placeholder="Model" required
                  [(ngModel)]="device.model" #model="ngModel">
                <small class="text-danger text-center" *ngIf="model.errors && addDeviceForm.submitted">
                  <p class="mb-0" *ngIf="model.errors.required">*Required</p>
                </small>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label for="year"><span class="maroon astrisk">&#10033;&nbsp;</span>Year</label>
                    <input type="number" class="form-control" id="year" name="year" placeholder="Year" required
                      [(ngModel)]="device.year" #year="ngModel" [customMin]="minYear" [customMax]="maxYear">
                    <small class="text-danger text-center" *ngIf="year.errors && addDeviceForm.submitted">
                      <p class="mb-0" *ngIf="year.errors.required">*Required</p>
                      <p class="mb-0"
                        *ngIf="!year.errors.required && (year.errors?.customMin || year.errors?.customMax)">Year can be
                        between {{minYear}} - {{maxYear}}</p>
                    </small>
                  </div>

                </div>
                <div class="col pl-0">
                  <div class="form-group">
                    <label for="color"> Color</label>
                    <input type="text" class="form-control" id="color" name="color" placeholder="Color"
                      [(ngModel)]="device.color" #color="ngModel">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light btn-80" data-dismiss="modal"
            (click)="resetAddDeviceForm()">CANCEL</button>
          <button type="submit" class="btn btn-primary btn-80">SAVE</button>
        </div>
      </form>
    </div>
  </div>
</div> -->

<!-- Import removeDevice modal -->
<div class="modal fade" id="importremoveDevice" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="importremoveDeviceTitle">Remove Devices from {{account.name}}</h5>
        <button id="closeRemoveDevice" type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="resetRemoveDeviceImport()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-2 pb-2 hide-x-scroll">
        <div class="form-group mb-0">
          <label class="heading">Upload UTF-8 Encoded CSV File</label><br>
          <label class="mt-2"><span class="text-muted font13-400">AccountId for {{account.name}}
              :</span><br>{{account.id}}</label>
          <div class="row mt-2 mb-3">
            <div class="col-12">
              <div class="custom-file">
                <input #devicesCompRemoveDevicesFromAccountInput type="file" accept=".csv" class="custom-file-input"
                  id="removeDeviceImport" (change)="onFileSelected($event.target.files, 'RemoveDevice')">
                <label class="custom-file-label" for="removeDeviceImport">{{importFileName.substring(0,40)}} <span
                    *ngIf="importFileName != CHOOSE_FILE">...</span></label>
              </div>
            </div>
            <div class="col-12" *ngIf="importFileName != CHOOSE_FILE"><span class="font11-400">{{importFileName}}</span>
            </div>
          </div>

          <label>
            <span class="text-muted font13-400">Format for Remove Device
              filename:</span><br>
            NCC_RemoveDevice_&lt;accountId&gt;_&lt;timestamp&gt;.csv</label><br>

          <label class="mt-1">
            <span class="text-muted font13-400">For example :</span><br>
            NCC_RemoveDevice_{{account.id}}_05132019101630.csv</label><br>

          <label class="mt-2">
            <span class="text-muted font13-400">CSV file data format :</span><br>
            VIN, reasonCode</label><br>
          <ul>
            <li class="text-muted txt-small">Both the fields are mandatory.</li>
            <li class="text-muted txt-small">ReasonCode could have value : SOLD.
            </li>
          </ul>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light btn-80" data-dismiss="modal"
          (click)="resetRemoveDeviceImport()">CANCEL</button>
        <button type="button" class="btn btn-primary btn-80" [disabled]="importFile == null"
          (click)="uploadFile()">UPLOAD</button>
      </div>
    </div>
  </div>
</div>

<!-- <app-review-devices [devices]="selectedDevices" [reviewDevicesHeader]="reviewDeviceModalMessages.header"
  [reviewDevicesMessage]="reviewDeviceModalMessages.message" [reviewDevicesNote]="reviewDeviceModalMessages.note"
  (closeEmitter)="resetSelectedDevices()" (saveEmitter)="reviewDevicesSubmit($event)"></app-review-devices> -->

<app-enrollment-status (saveEmitter)="refreshDeviceList()" #enrollmentStatusModal></app-enrollment-status>